import { TablePaginationConfig } from 'antd'
import Strapi, { EndpointQueryParameters } from '../../types/strapi/strapi'
import { useSearchParams } from 'react-router-dom'
import qs from 'qs'

export default function useTablePagination(
    params: EndpointQueryParameters,
    data?: Strapi<any>
): TablePaginationConfig {
    const [searchParams, setSearchParams] = useSearchParams()

    return {
        current: params.pagination?.page,
        pageSize: params.pagination?.pageSize,
        total: data?.meta?.pagination.total,
        showTotal(total) {
            return `Всего: ${total} шт.`
        },
        onChange(page, pageSize) {
            searchParams.set('pagination', qs.stringify({ page, pageSize }))
            setSearchParams(searchParams)
            document.querySelector('.ant-table-body')?.scrollTo(0, 0)
        },
    }
}
